module.exports = __webpack_public_path__ + "static/img/zpborder.7cd9a2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/weekjd/zpborder.png
// module id = BaIN
// module chunks = 2